module.exports = __webpack_public_path__ + "static/media/Document.32331273.svg";